import React from 'react'



export default function Team(props) {
    const team = props.team; 
       
   
    const totalPlayerSalary = team.reduce( (sum, player) => sum +  player.salary, 0)

    
    
    return (
        <div>
            <h2>Selected Total Player: {team.length}</h2>
            {   
                team.map(selectPlayer => <p> {selectPlayer.id}- {selectPlayer.name} - Salary: {selectPlayer.salary}</p> )
            }
            <h3>Total Player's Budget: {totalPlayerSalary}</h3>
        </div>
    )
}
